<template>
  <v-navigation-drawer
    persistent
    :mini-variant="false"
    :clipped="true"
    enable-resize-watcher
    :fixed="false"
    :value="$store.state.ui.openLeftNavDrawer"
    app
  >
    <v-card v-if="person" :class="`referralid-${person.referralid}`">
      <v-card-title v-if="person" class="card-title">
        <h3>
          #{{ personId }} - {{ person.nickname }}

          <br />
          <small>
            {{ person.title }} {{ person.firstname }} {{ person.middlenames }}
            {{ person.surname }}
          </small>
        </h3>
      </v-card-title>

      <!-- <v-card-message v-if="pharmacist.name">{{pharmacist}}</v-card-message> -->
      <v-card-text>
        <v-layout pl-1 column v-if="person && person.practitioner">
          <v-row>
            <v-col>
              <v-btn icon :href="'mailto:' + person.contactemailaddress">
                <v-icon>mail</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-dialog card width="650px">
                <template #activator="{ on }">
                  <v-btn
                    v-on="on"
                    @click="
                      () => {
                        if ($refs.pubRegPreview) {
                          $refs.pubRegPreview.refresh();
                        }
                      }
                    "
                    text
                    outlined
                    color="primary"
                  >
                    PR Preview
                  </v-btn>
                </template>
                <template #default>
                  <public-register-preview
                    ref="pubRegPreview"
                    :person-id="personId"
                  />
                </template>
              </v-dialog>
            </v-col>
          </v-row>

          <v-flex v-if="person && person.practitioner">
            <strong v-if="activeScope">
              {{ activeScope }}
            </strong>
            <span v-if="person.practitioner.registrationdate">
              since
              <strong>
                {{ person.practitioner.registrationdate | formatDate() }}
              </strong>
            </span>
          </v-flex>

          <v-flex v-if="person.practitioner.practicingstatus">
            <v-icon
              size="small"
              :color="
                person.practitioner.practicingstatus.name.includes('current')
                  ? 'green'
                  : 'orange'
              "
            >
              circle
            </v-icon>
            <strong> {{ person.practitioner.practicingstatus.name }} </strong>
          </v-flex>

          <v-flex v-if="person.apc">
            <v-icon size="small" :color="apcCurrent ? 'green' : 'orange'">
              circle
            </v-icon>
            <strong>
              {{ person.apc.certificatetype.name }}
            </strong>
            expires
            <strong>
              {{ person.apc.expirydate | formatDate() }}
            </strong>
          </v-flex>
          <v-progress-linear v-if="$store.state.people.loading" indeterminate />
        </v-layout>
      </v-card-text>
    </v-card>

    <v-list>
      <v-list-item @click="$vuetify.goTo('#personal', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>person</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          Personal Details
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="$vuetify.goTo('#addresses', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>contact_mail</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>Addresses</v-list-item-content>
      </v-list-item>

      <v-list-item @click="$vuetify.goTo('#certs', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>description</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>APC History</v-list-item-content>
      </v-list-item>

      <v-list-item @click="$vuetify.goTo('#conditions', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>supervised_user_circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>Conditions</v-list-item-content>
      </v-list-item>

      <v-list-item @click="$vuetify.goTo('#scopes', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>assignment</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>Scopes of Practice</v-list-item-content>
      </v-list-item>

      <v-list-item @click="$vuetify.goTo('#forms', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>inbox</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>Online Forms</v-list-item-content>
      </v-list-item>

      <v-list-item @click="$vuetify.goTo('#payments', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>payment</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>Payments</v-list-item-content>
      </v-list-item>

      <v-list-item @click="$vuetify.goTo('#quals', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>school</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>Qualifications</v-list-item-content>
      </v-list-item>

      <v-list-item @click="$vuetify.goTo('#verifications', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>shield</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>Verifications</v-list-item-content>
      </v-list-item>

      <!-- <v-list-item @click="$vuetify.goTo('#compliance', { offset: 10 })">
        <v-list-item-avatar>
          <v-icon>assessment</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>Compliance</v-list-item-content>
      </v-list-item> -->
    </v-list>
    <v-divider />
    <recently-viewed-people />
  </v-navigation-drawer>
</template>

<script>
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import recentlyViewedPeople from "@/components/people/recentlyViewed.vue";
import publicRegisterPreview from "@/components/pharmacists/public-register-preview";

export default {
  name: "PersonLeftNavDrawer",
  data() {
    return {
      loading: false
      // person: {}
    };
  },
  computed: {
    personId() {
      return this.$route.params.id;
    },
    activeScope() {
      try {
        return String(
          this.person?.practitioner?.scopesonpractice?.find(s => {
            return !s.inactive && !s.inactivedate;
          }).scopesofpractice.name
        );
      } catch (e) {
        return false;
      }
    },
    apcCurrent() {
      if (!this.person?.apc?.expirydate) {
        return false;
      }

      return moment(this.person.apc.expirydate).isAfter();
    },
    person() {
      return this.$store.getters.getById(this.personId);
    }
  },

  components: {
    recentlyViewedPeople,
    publicRegisterPreview
  }
};
</script>

<style scoped>
.card-title {
  word-break: normal;
}
</style>
